export const setUnacknowledgedNotifications = (state, notifications) => {
    state.unacknowledgedNotifications = notifications
}

export const setNotificationsCount = (state, count) => {
    state.notificationsCount = count
}

export const removeNotification = (state, notificationId) => {
    state.unacknowledgedNotifications = state.unacknowledgedNotifications.filter(
        notification => notification.id !== notificationId
    )
    state.notificationsCount = state.unacknowledgedNotifications.length
}
